import { render, staticRenderFns } from "./ParkingBarriersDataTable.vue?vue&type=template&id=1003defe&scoped=true&"
import script from "./ParkingBarriersDataTable.vue?vue&type=script&lang=js&"
export * from "./ParkingBarriersDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ParkingBarriersDataTable.vue?vue&type=style&index=0&id=1003defe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1003defe",
  null
  
)

export default component.exports